<template>
  <div class="basicInformation common_contentBox">
    <div class="title">基础信息</div>
    <el-form class="common_form" :class="noBorderMode ? 'formReadOnlyMode' : ''" label-position="left" ref="basicInformationForm" :rules="rules" label-width="140px" :model="formData">
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="活动编号">
            <el-input v-model="formData.activityCode" disabled />
          </el-form-item>
        </el-col>
        <!-- <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="财务体系" prop="financialSystemCode">
            <el-select v-model="formData.financialSystemCode" placeholder="请选择" :disabled="financialSystemList.length<1">
              <el-option v-for="item in financialSystemList" :key="item.comCode" :label="item.comName" :value="item.comCode" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="货币种类" prop="currencyCode">
            <el-select v-model="formData.currencyCode" placeholder="请选择" disabled>
              <el-option v-for="item in currencyList" :key="item.currCode" :label="item.currName" :value="item.currCode" />
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="签约类型">
            <el-input v-model="formData.unionChannelType" disabled />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="公司名称">
            <el-input v-model="formData.applyUserName" disabled />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="申请时间">
            <el-input v-model="formData.applyTime" disabled />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="对应销售" prop="saler">
            <el-select
              :disabled="readOnlyMode || (isEditable !== 0 && isEditable !== 1)"
              v-model="formData.saler"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="saleLoading"
              @change="salerChange"
            >
              <el-option v-for="item in saleList" :key="item.userId" :label="item.combination" :value="item.userId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="联系方式" prop="applyUserTel">
            <el-input v-model="formData.applyUserTel" :disabled="readOnlyMode" />
          </el-form-item>
        </el-col>
        <!--        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">-->
        <!--          <el-form-item label="销售姓名">-->
        <!--            <el-input v-model="formData.channelSalerName" disabled />-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="活动分类" prop="activityClassificationCode">
            <el-select v-model="formData.activityClassificationCode" :disabled="readOnlyMode || (isEditable !== 0 && isEditable !== 1)" placeholder="请选择">
              <el-option v-for="item in activityClassificationList" :key="item.fieldKey" :label="item.fieldValue" :value="item.fieldKey"
                         v-if="!($store.state.useSimplifiedForm && ['AC_01','AC_03'].includes(item.fieldKey) && formData.activityClassificationCode !== item.fieldKey)"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="活动类型" prop="activityTypeCode">
            <el-select v-model="formData.activityTypeCode" :disabled="readOnlyMode" placeholder="请选择" @change="activityTypeChange">
              <el-option v-for="item in activityTypeList" :key="item.id" :label="item.typeName" :value="item.id"
                         v-if="!($store.state.useSimplifiedForm && ['11N（单一客户的专项交流）','样板参观','拜节会','会议+展位'].includes(item.typeName) && formData.activityTypeCode !== item.id)"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="细分活动类型" prop="activitySubtypeCode">
            <el-select v-model="formData.activitySubtypeCode" :disabled="readOnlyMode" placeholder="请选择">
              <el-option v-for="item in subdivideActivityTypeList" :key="item.id" :label="item.typeName" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="50">
        <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
          <el-form-item class="special" label="活动名称" prop="activityName">
            <el-input v-model="formData.activityName" :disabled="readOnlyMode" maxlength="200" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="50">
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="预计举办日期" prop="expectStartDate">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              :disabled="readOnlyMode"
              type="datetime"
              placeholder="选择日期"
              v-model="formData.expectStartDate"
              :picker-options="pickerOptions"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="预计结束日期" prop="expectEndDate">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              :disabled="readOnlyMode"
              type="datetime"
              placeholder="选择日期"
              v-model="formData.expectEndDate"
              :picker-options="pickerOptions"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { newApplicationFormApi } from '../../service';
import { bus } from '@/utils/bus.js';
import { isNotEmpty } from '@/utils/utils';
export default {
  data () {
    let phoneNumberValidator = (rule, value, callback) => {
      if (!/^[0-9]{7,}$/.test(value)) {
        callback(new Error('手机号格式有误'));
      } else {
        callback();
      }
    };
    let dateValidator = (rule, value, callback) => {
      if (this.noBorderMode) {
        callback();
        return;
      }
      let currentDate = new Date(new Date().format('yyyy-MM-dd')).getTime();
      let startDate = new Date(new Date(this.formData.expectStartDate).format('yyyy-MM-dd')).getTime();
      if (startDate < currentDate) {
        callback(new Error('预计举办日期不能小于当前日期'));
      } else if (this.formData.expectStartDate > this.formData.expectEndDate) {
        callback(new Error('开始日期不能大于结束日期'));
      } else {
        this.$refs.basicInformationForm.clearValidate(['expectStartDate', 'expectEndDate']);
        callback();
      }
    };
    return {
      rules: {
        applyUserTel: [
          { validator: phoneNumberValidator, trigger: 'blur' }
        ],
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        activityClassificationCode: [
          { required: true, message: '请选择活动分类', trigger: 'change' }
        ],
        activityTypeCode: [
          { required: true, message: '请选择活动类型', trigger: 'change' }
        ],
        activitySubtypeCode: [
          { required: true, message: '请选择细分活动类型', trigger: 'change' }
        ],
        expectStartDate: [
          { required: true, message: '请选择开始日期', trigger: 'change' },
          { validator: dateValidator, trigger: 'change' }
        ],
        expectEndDate: [
          { required: true, message: '请选择结束日期', trigger: 'change' },
          { validator: dateValidator, trigger: 'change' }
        ],
        financialSystemCode: [
          { required: true, message: this.$t('newApp.BasicInfo.psafs'), trigger: 'change' }
        ],
        currencyCode: [
          { required: true, message: this.$t('newApp.BasicInfo.psac'), trigger: 'change' }
        ],
        saler: [
          { required: true, message: '请选择对应销售', trigger: 'change' }
        ]
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      financialSystemList: [], // 财务体系列表
      currencyList: [], // 货币种类列表
      saleList: [], // 对应销售列表
      activityClassificationList: [], // 活动分类
      activityTypeList: [], // 活动类型列表
      subdivideActivityTypeList: [], // 细分活动类型列表
      formData: {
      },
      productlineOtherShow: false,
      saleLoading: false,
      readOnlyMode: false, // 只读模式
      isEditable: 0
    };
  },
  props: {
    editEchoData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 无边框模式
    noBorderMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        this.saleLoading = true;
        newApplicationFormApi.getSalesmanList(query).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.saleList = res.data.map(item => {
                return {
                  ...item,
                  combination: `${item.userName}/${item.deptName}`
                };
              });
            } else {
              this.saleList = [];
            }
          }
          this.saleLoading = false;
        });
      } else {
        this.saleList = [];
      }
    },
    salerChange (val, flag) {
      let salerObj = this.arrayQuery(val, this.saleList, 'userId');
      this.formData.salerId = salerObj.userId;// 对应销售ID
      this.formData.salerName = salerObj.userName;// 对应销售姓名
      this.formData.salerDeptCode = salerObj.deptCode;// 对应销售部门code
      this.formData.salerDeptName = salerObj.deptName;// 对应销售部门名称
      this.getFinancialSystemList();
      this.$emit('salerChange', {
        salerId: this.formData.salerId,
        salerName: this.formData.salerName,
        salerDeptCode: this.formData.salerDeptCode,
        belongToSmb: salerObj.belongToSmb,
        editLoadFlage: flag
      });
    },
    activityTypeChange (val) {
      let item = this.arrayQuery(val, this.activityTypeList, 'id');
      this.$set(this.formData, 'activitySubtypeCode', '');
      this.subdivideActivityTypeList = item.subTypeList;
      if (item.subTypeList.length === 1) {
        this.$set(this.formData, 'activitySubtypeCode', item.subTypeList[0].id);
      }
    },
    arrayQuery (val, list, findKey) {
      return list.find(item => {
        return item[findKey] === val;
      });
    },
    getDraftData () {
      // 货币name过滤
      if (this.formData.currencyCode) {
        this.formData.currencyType = this.formData.currencyCode;
      }
      if (this.formData.activityClassificationCode) {
        // 活动分类名称过滤
        this.formData.activityClassification = this.arrayQuery(this.formData.activityClassificationCode, this.activityClassificationList, 'fieldKey').fieldValue;
      }
      // 活动类型名称过滤
      if (this.formData.activityTypeCode) {
        this.formData.activityType = this.arrayQuery(this.formData.activityTypeCode, this.activityTypeList, 'id').typeName;
      }
      if (this.formData.activitySubtypeCode) {
        // 细分活动类型名称过滤
        this.formData.activitySubtype = this.arrayQuery(this.formData.activitySubtypeCode, this.subdivideActivityTypeList, 'id').typeName;
      }
      return this.formData;
    },
    getFormData () {
      return new Promise((resolve, reject) => {
        this.$refs['basicInformationForm'].validate((valid) => {
          if (valid) {
            this.formData.currencyType = this.formData.currencyCode;

            // 活动分类名称过滤
            this.formData.activityClassification = this.arrayQuery(this.formData.activityClassificationCode, this.activityClassificationList, 'fieldKey').fieldValue;
            // 活动类型名称过滤
            this.formData.activityType = this.arrayQuery(this.formData.activityTypeCode, this.activityTypeList, 'id').typeName;
            // 细分活动类型名称过滤
            this.formData.activitySubtype = this.arrayQuery(this.formData.activitySubtypeCode, this.subdivideActivityTypeList, 'id').typeName;
            resolve(this.formData);
          } else {
            document.querySelector('.contentScrollbar>.el-scrollbar__wrap').scrollTop = 0;
            this.$message.error('基础信息有未填写字段,请仔细检查');
          }
        });
      });
    },
    getActivityList () {
      let params = ['union_market_help', 'activity_classification', 'expense_detail_item', 'qdquick_activity_classification'];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          this.activityClassificationList = res.data.qdquick_activity_classification;
          this.activityFormsList = res.data.activity_forms;
        }
      });
    },
    getActivityTypeList () {
      newApplicationFormApi.getActivityType('ChannelQuickApplication').then(res => {
        if (res.status === '200') {
          this.activityTypeList = res.data;
          if (this.$route.query.activityCode && this.formData.activityTypeCode) {
            // 编辑回显  获取细分活动列表
            this.subdivideActivityTypeList = this.arrayQuery(this.formData.activityTypeCode, this.activityTypeList, 'id').subTypeList;
          }
        }
      });
    },
    getActivityCode () {
      newApplicationFormApi.getActivityCode().then(res => {
        if (res.status === '200') {
          this.$set(this.formData, 'activityCode', res.data.code);
          this.$set(this.formData, 'applyTime', res.data.creatTime);
          bus.$emit('activityCode', this.formData.activityCode);
        }
      });
    },
    getCustomerList (name) {
      let params = {
        checkType: 'LIKE',
        customerName: name,
        pageSize: 1,
        pageNum: 1
      };
      newApplicationFormApi.getCustomerList(params).then(res => {
        if (res.status === '200') {
          let data = res.data && res.data.data.length > 0 ? res.data.data[0].name : '';
          this.$set(this.formData, 'channelSalerName', data);
        }
      });
    },
    getFinancialSystemList () {
      newApplicationFormApi.getFinancialSystemList(this.formData.salerId).then(res => {
        if (res.status === '200') {
          if (isNotEmpty(res.data)) {
            let defaultValFlag = res.data.some(item => {
              return item.comCode === '111';
            });
            // 如果新建申请 财务体系中没有福建 则默认第一个
            if (!defaultValFlag) {
              this.$set(this.formData, 'financialSystemCode', res.data[0].comCode);
              this.formData.financialSystemName = res.data[0].comName;
            } else {
              // 财务体系默认为福建
              this.$set(this.formData, 'financialSystemCode', '111');
              this.formData.financialSystemName = this.$t('general.fujian');
            }
          }
          this.financialSystemList = res.data;
        }
      });
    },
    getSalerData (flag) {
      if (this.formData.salerId) {
        newApplicationFormApi.getSalesmanList(this.formData.salerId).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.saleList = res.data.map(item => {
                return {
                  ...item,
                  combination: `${item.userName}/${item.deptName}`
                };
              });
              this.getFinancialSystemList(this.saleList[0].userId);
              this.salerChange(this.formData.salerId, flag);
            }
          }
        });
      }
    }
  },
  mounted () {
    let userInfo = this.$store.state.userInfo;

    if (this.$route.query.activityCode) {
      // 编辑处理
      if (this.noBorderMode) {
        // 无边框模式 = 无边框 + 只读模式
        this.readOnlyMode = true;
      }
      if (this.$store.state.newApplication.editFlag) {
        // 详情页跳转过来 可编辑控制
        this.isEditable = this.$store.state.newApplication.editFlag;
        let flag = Number(this.$store.state.newApplication.editFlag);
        if (flag === 3) {
          this.readOnlyMode = true;
        }
      }
      // 编辑回显
      this.formData = {
        ...this.formData,
        ...this.editEchoData.marketActivity
      };
      // this.formData.financialSystemName = '福建';
      // this.formData.financialSystemCode = '111';
      this.formData.currencyCode = '人民币';
      if (this.formData.salerId) {
        let salerText = `${this.formData.salerName}/${this.formData.salerDeptName}`;
        this.$set(this.formData, 'saler', salerText);
        this.getSalerData(2);
      }
      this.$nextTick(() => {
        this.$refs.basicInformationForm.clearValidate();
      });
    } else {
      // 新增数据初始化
      // this.formData.financialSystemName = '福建';
      // this.formData.financialSystemCode = '111';
      this.formData.currencyCode = '人民币';
      this.getCustomerList(userInfo.sysUser.userName);

      this.$set(this.formData, 'applyUserTel', userInfo.phone);
      this.formData.applyUserId = userInfo.sysUser.userId;
      this.formData.applyUserName = userInfo.sysUser.userName;
      this.formData.applyUserDeptCode = userInfo.sysUser.deptCode;
      this.formData.applyUserDeptName = userInfo.sysUser.deptName;
      this.formData.applyUserType = userInfo.userType;
      this.formData.needOrganizer = 0;

      this.getActivityCode(); // 获取活动编号及申请时间
      this.$set(this.formData, 'unionChannelType', userInfo.partnerTypeName);
    }

    this.getActivityList(); // 获取[活动分类,活动目的,活动形式,产品线]列表
    this.getActivityTypeList(); // 获取活动类型列表
  }
};
</script>

<style lang="scss" scoped>
.basicInformation {
  >.title{
    font-size: 16px;
    font-weight: bold;
    margin: 3px 0 20px;
  }
}
</style>
